const FintechNotHiredI18n = {
  title: {
    contractValidationError: 'No fue posible validar el contrato!',
    productNotHired: 'Todavía no has contratado {{ serviceName }}.',
    wishToHire: 'Quiero contratar',
    sasNotFoundClientInformations: 'No se pudo obtener la información de la licencia',
    notInBeta: 'Funcionalidad en fase de pruebas',
    clickHere: 'Haga clic aquí',
  },
  service: {
    BOLETO_RAPIDO: 'Boleto Rápido',
    PIX: 'Pix Imediato',
    PAGAMENTO: 'Pagos',
    DDA: 'DDA',
    SCORE: 'Sankhya Score',
  },
  message: {
    contractValidationUnexpectedError: 'Durante el proceso de validación se encontró un problema inesperado. Espere unos minutos, si persiste, contacte al equipo de soporte.',
    contractValidationError: 'Durante el proceso de validación se encontró el siguiente error: ',
    serviceNotIncludedInCurrentPack: 'El paquete de servicios actualmente contratado "{{ package }}" no contempla el servicio de "{{ serviceName }}".',
    clickHereToContractPackage: '{{ hireButton }} para contratar un paquete que incluya este servicio.',
    availableOnlyWhenBankSlipHired: 'Esta configuración solo está disponible para quienes ya han contratado Boleto Rápido.',
    simpleOperationsWhenBankSlipHired: 'Con él, puedes emitir boletos de forma simple e integrada a tu ERP.',
    availableOnlyWhenPixHired: 'Esta configuración solo está disponible para quienes ya han contratado Pix Imediato.',
    simpleOperationsWhenPixHired: 'Con él, puedes realizar cobros de forma simple e integrada a tu ERP.',
    availableOnlyWhenPaymentsHired: 'Esta configuración solo está disponible para quienes ya han contratado el servicio de Pagos.',
    simpleOperationsWhenPaymentsHired: 'Con él, puedes automatizar tu flujo de pagos de forma simple e integrada a tu ERP.',
    sasNotFoundClientInformations:
      'Para validar el contrato de servicio Fintech, necesita tener un servidor de licencias activo. Verifique su licencia y el estado de la conexión con el servidor de licencias.',
    notInBetaDescription:
      'Esta funcionalidad se encuentra en fase de pruebas (Beta) con un grupo limitado de clientes y será liberada para todos en breve. Si tienes interés en ser un Beta de esta funcionalidad, comunícate con tu Gerente de Relaciones.',
  },
};

export default FintechNotHiredI18n;
